import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import {useContext, useEffect} from "react";
import Menu from "./components/Menu/Menu";
import Home from "./components/Home/Home";
import Profile from "./components/Profiles/Profile";
import Attendance from "./components/Attendance/Attendance";
import 'bootstrap/dist/css/bootstrap.min.css';
import Daycount from "./components/Attendance/Daycount";
import NavMenu from "./components/NavMenu/NavMenu";
import DataReset from "./components/Excel/DataReset";
import Login from "./components/Authentication/Login";
import Logout from "./components/Authentication/Logout";
import EditMenu from "./components/Menu/EditMenu";
import RsvpCount from "./components/Menu/RsvpCount";
import UserContext from "./contexts/UserContext";
import SabeelUpload from "./components/Excel/SabeelUpload";
import Payment from "./components/Takhmeen/Payment";
import BottomNav from "./components/NavMenu/BottomNav";
import ViewPayment from "./components/Takhmeen/ViewPayment";
import UserPayment from "./components/Takhmeen/UserPayment";
import Feedback from "./components/Menu/Feedback";
import FeedbackReport from "./components/Menu/FeedbackReport";
import Niyaaz from "./components/Takhmeen/Niyaaz";
import TiffinDataUpload from "./components/Excel/TiffinDataUpload";
import TiffinSizeUpload from "./components/Excel/TiffinSizeUpload";
import GeneralDataUpdate from "./components/Excel/GeneralDataUpdate";
import Notification from "./components/Notification/Notification";
import QRScanner from "./components/Scanning/ThaaliScan";

const App = () => {

  useEffect(() => {
    console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV === 'production') {
      console.log = function () {};
      console.warn = function () {};
      console.error = function () {};
    }
  }, []);

  const {user,setUser} = useContext(UserContext);
  const design = (
    <>
      <BrowserRouter>
              <NavMenu/>
              <Routes>
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/menu" element={<Menu />} />
                <Route exact path="/rsvp" element={<EditMenu />} />
                {user && user.role==='admin'?<Route exact path="/rsvpCount" element={<RsvpCount />} />:null}
                {/* <Route exact path="/attendance" element={<Attendance />} /> */}
                {user && user.role==='admin'?<Route exact path="/attendanceCount" element={<Attendance />} />:null}
                {user && user.role==='admin'?<Route exact path="/dailyCount" element={<Daycount />} />:null}
                <Route exact path="/profile" element={<Profile />} />
                {/* <Route exact path="/uploadTiffinData" element={<TiffinDataUpload />} /> */}
                {/* <Route exact path="/uploadTiffinSizes" element={<TiffinSizeUpload />} /> */}
                {/* <Route exact path="/editGeneralData" element={<GeneralDataUpdate />} /> */}
                <Route exact path="/reset" element={<DataReset />} />
                 {/* <Route exact path="/sabeelUpload" element={<SabeelUpload />} /> */}
                {user && user.role==='admin'?<Route exact path="/niyaazUpload" element={<Niyaaz />} />:null}
                {user && user.role==='admin'?<Route exact path="/notify" element={<Notification />} />:null}
                {user && user.role==='admin'?<Route exact path="/payment" element={<Payment />} />:null}
                {user && user.role==='admin'?<Route exact path="/viewPayment" element={<ViewPayment />} />:null}
                <Route exact path="/userPayment" element={<UserPayment/>} />
                <Route exact path="/feedback" element={<Feedback/>} />
                {user && (user.role==='admin' || user.role==='fmbmember')?<Route exact path="/feedbackReport" element={<FeedbackReport/>} />:null}
                {user && user.role==='admin'?<Route exact path="/scanning" element={<QRScanner />} /> :null}
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/logout" element={<Logout />}/>
                {/* <Route exact path="/view" element={<View />} /> */}
              </Routes>
              <div style={{height:'70px'}}></div>
              <BottomNav/>
        </BrowserRouter>  
     </>
  )
  return design;
}

export default App;